// src/actions/quizActions.js
export const setQuizAnswer = (quizId, answer) => ({
  type: 'SET_QUIZ_ANSWER',
  payload: { quizId, answer },
});